import React from "react"
import PropTypes from "prop-types"

import Appical from "./Appical"
import NN from "./NN"
import Partou from "./Partou"
import TNO from "./TNO"
import Olvg from "./Olvg"
import Ns from "./Ns"
import Heineken from "./Heineken"
import Vanlanschot from "./Vanlanschot"
import BakerTillyBerk from "./BakerTillyBerk"
import Landal from "./Landal"
import RolandBerger from "./RolandBerger"
import HP from "./HP"
import Motion from "./Motion"
import DT from "./DT"
import EP from "./EP"
import NNCZ from "./NN-CZ"
import NNTR from "./NN-TR"
import NNSK from "./NN-SK"
import NNES from "./NN-ES"
import Capgemini from "./Capgemini"
import { currentCompany } from "../../../constants"
import Worldline from "./Worldline"
import Antonius from "./Antonius"
import KPMG from "./kpmg"
import LegerDesHeils from "./LegerDesHeils"
import Sanofi from "./Sanofi"
import Ministerievandefensie from "./ministerievandefensie"
import Asml from "./Asml"
import Allianzpartners from "./Allianzpartners"
import SwissLog from "./SwissLog"
import Arkin from "./Arkin"
import Allianzgi from "./Allianzgi"
import Ergomed from "./Ergomed"

/**
 * Logo component displays the logo of the current company based on the value of `currentCompany`.
 * 
 * @param {boolean} altLogo - Whether to display an alternate version of the logo.
 * @param {number|string} width - The width of the logo.
 * @param {number|string} height - The height of the logo.
 * @param {string} className - Additional CSS classes to apply to the logo.
 * @param {string} color - The color of the logo.
 * 
 * @returns {JSX.Element} - The logo component.
 */
const Logo = ({ altLogo, ...props }) => {
    switch (currentCompany) {
    case "nn": return <NN {...props} />
    case "partou": return <Partou {...props} />
    case "tno": return <TNO {...props} />
    case "olvg": return <Olvg {...props} />
    case "ns": return <Ns {...props} />
    case "heineken": return <Heineken {...props} />
    case "vanlanschot": return <Vanlanschot {...props} />
    case "bakertilly": return <BakerTillyBerk {...props} />
    case "landal": return <Landal {...props} />
    case "rolandberger": return <RolandBerger {...props} />
    case "hp": return <HP {...props} />
    case "motion": return <Motion {...props} />
    case "dt": return <DT {...props} />
    case "ep": return <EP {...props} />
    case "nn-cz": return <NNCZ {...props} />
    case "nn-sk": return <NNSK {...props} />
    case "nn-tr": return <NNTR {...props} />
    case "nn-es": return <NNES {...props} />
    case "capgemini": return <Capgemini {...props} />
    case "worldline": return <Worldline {...props} />
    case "antonius": return <Antonius {...props} />
    case "kpmg": return <KPMG {...props} />
    case "legerdesheils": return <LegerDesHeils {...props} />
    case "sanofi": return <Sanofi {...props} />
    case "ministerievandefensie": return <Ministerievandefensie {...props} />
    case "asml": return <Asml {...props} />
    case "allianzpartners": return <Allianzpartners {...props} />
    case "swisslog": return <SwissLog {...props} />
    case "arkin": return <Arkin {...props} />
    case "allianzgi": return <Allianzgi {...props} />  
    case "ergomed": return <Ergomed {...props} />
    default: return <Appical {...props} />
    }
}

Logo.propTypes = {
    altLogo: PropTypes.bool,
}

Logo.defaultProps = {
    altLogo: false,
}

export default Logo
